// extracted by mini-css-extract-plugin
export default {"dialogBox":"EditSuggestedQuestion_dialogBox__iCSGK","closeButton":"EditSuggestedQuestion_closeButton__NvZGD","placeholder":"EditSuggestedQuestion_placeholder__ULLKc"};